<template>
    <div v-loading.fullscreen.lock="loading">
        <div v-show="test" class="sign" style="position:absolute;top:0;z-index:9999;bottom:0">
            <signature @closePop="closePop" @saveImg="complete"></signature>
        </div>
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="姓名" class="form-item">
                <el-input class="input input-sel" @focus="openPersonnel" v-model="form.name" placeholder="请选择慰问人员的姓名" @change="handleBlur"></el-input>
                <span class="sel-txt" @click="openPersonnel">选择</span>
            </el-form-item>
            <el-form-item label="科室" class="form-item">
                <p>{{form.deptName}}</p>
            </el-form-item>
            <el-form-item label="慰问类型" class="form-item">
                <el-radio-group v-model="form.comfortType">
                    <el-radio label="1" >住院慰问</el-radio>
                    <el-radio label="2" >亲属去世</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="事由" class="form-item" v-if="form.comfortType==1">
                <el-input type="textarea" v-model="form.desc" maxlength="200" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="申请补助金额" class="form-item overflowText" v-if="form.comfortType==2">
                <el-input 
                    class="input input-sel" 
                    v-model="form.applyMoney" 
                    placeholder="1000" 
                    @input="changgeNumber()"
                    maxlength="15"
                >
                </el-input>
                <span>元</span>
            </el-form-item>

            <el-form-item label="申请补助事由" class="form-item overflowText" v-if="form.comfortType==2">
                <el-input type="textarea" v-model="form.desc" maxlength="200" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="签名" class="form-item sign">
                <div v-if="form.imgData" class="resign">
                    <img class="sign-img" :src="form.imgData"/>
                    <span @click="showPopup" class="resign-txt">重新签名</span>
                </div>
                <el-button v-else class="sign-btn" @click="showPopup"><span class="img"></span>签名</el-button>
            </el-form-item>

            <el-form-item class="submit-btn" v-if="bottomShow">
                <el-button type="primary" class="btn-cancel" @click="cancel">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 认</el-button>
            </el-form-item>
        </el-form>
    
    </div>
</template>
<script>
  import { toast } from "@/common/api/api.js";
  import { comfortApply,signinHonoreeSignature,getWXInfo} from "@/common/api";
  import signature from "../../components/signature.vue";
  export default {
    name:"condoleApply",
    components: {
        signature
    },
    data() {
      return {
        loading:false,
        form: {
          name: '',
          deptName:"",
          unionName:"",
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          comfortType:"1",
          desc: '',
          nameId:"", // 申请人ID
          imgData:"",
          applyMoney:1000,
        },
        test:false,
        loginInfo:"",
        validateData:[
            {item:"imgData",code:"请签名,不能为空"},
            {item:"desc",code:"申请事由不能为空"},
            {item:"nameId",code:"申请人不能为空"},
            {item:"comfortType",code:"慰问类型需要选择"},
        ],
        docmHeight: document.documentElement.clientHeight ||document.body.clientHeight,
        showHeight: document.documentElement.clientHeight ||document.body.clientHeight,
        bottomShow:true
      }
    },
    created(){
        this.loginInfo= JSON.parse(window.localStorage.getItem("loginInfo"));
        //获取需要跳转得路由地址 并保存
        this.router=this.$route.query.router;
        if(selPerson){
            this.form.name=selPerson.name;
            this.form.deptName=selPerson.deptName;
            this.form.unionName=selPerson.unionName;
            this.form.nameId=selPerson.id;
        }
    },
    watch:{   
      showHeight:function() {
          if(this.docmHeight > this.showHeight){
            //隐藏
              this.bottomShow=false
          }else{
            //显示
              this.bottomShow=true
          }
      }
    },
    mounted(){
        window.onresize = ()=>{
            return(()=>{
                this.showHeight = document.documentElement.clientHeight || document.body.clientHeight;
            })()
        }
    },

    methods: {
        changgeNumber(){
            this.form.applyMoney = this.form.applyMoney.replace(/[^\d]/g,'');
        },
        validate(){
            let obj = {flag:true}
            for(let a=0;a<this.validateData.length;a++){
                if(!this.form[this.validateData[a]]){
                    obj.flag = false;
                    obj.token = a;
                    return obj
                }
            }
            return obj
        },

        moneyCheck(str){
            this.form.applyMoney = this.form.applyMoney.replace(/\s+/g,'');
        },

        onSubmit() {
            let reg=/(^[1-9]([0-9]+)?(.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]{1,2}?$)/;
            if(!reg.test(this.form.applyMoney)||this.form.applyMoney.length>15){
              toast(this,"金额只能输入15位,保留小数点后两位","error");  
              return;
            }
            this.loading=true;
            comfortApply({
                handle:this.loginInfo.id,
                nameId:this.form.nameId,
                comfortType:this.form.comfortType,
                money:this.form.applyMoney,
                reason:this.form.desc,
                applierSign:this.form.imgData,
                name:this.loginInfo.name,
                company:this.loginInfo.unionName,
            }).then(res => {
                this.loading=false;
                if(res.code==200){
                    toast(this,"提交成功");
                    this.$router.push({
                        path:"/condoleList",
                    });
                }else{
                    toast(this,res.message,"error");
                }
            })
        },
        cancel(){
            this.form.nameId="";
            this.form.name="";
            this.form.deptName="";
            this.form.unionName="";
            this.form.comfortType="1";
            this.form.desc="";
            this.form.imgData="";
        },
        //人员管理
        openPersonnel() {
            this.$router.push({
                path:"/personnelManagement",
                query:{
                    status:1, // 1 选择人员
                }
            });
        },
        myCondole(){
            this.$router.push("/myCondole");
        },
        complete(data) {
            if(data){
                this.form.imgData=data;
                this.test = false;
            }
        },
        showPopup() {
            this.test = !this.test;
        },
        closePop() {
            this.test = false;
        },
        handleBlur(){
            document.activeElement.blur();
        }
    }
  }
</script>

<style lang="stylus" type="stylesheet/stylus">
@import "../../assets/stylus/theme.styl"
    .sign{
        #wrapper{
            .rewrite{
                right:0 !important;
                left: 50% !important;
                top:-60%;
                transform: rotate(270deg) translateY(-50%) !important;
            }
        }
    }
    .el-form{
        .el-textarea .el-input__count{
            line-height:13px;
            font-size:12px;
        }
        .overflowText{
            .el-form-item__label {
                line-height:24px;
                text-align:center !important;
            }
        }
        .sign{
            .el-form-item__label{
                position:absolute;
                top:50%;
                transform:translateY(-50%);
            }
            .resign{
                display:flex;
                justify-content:space-between;
                align-items:center;
                .sign-img{
                    width:200px;
                    height:150px;
                    transform:rotate(90deg);
                }
            }
        }
        .form-item{
            background:#fff;
            padding:10px 20px;
            margin-bottom:0;
            border-bottom:1px solid #f4f4f4;
            position:relative;
            .el-form-item__label {
                text-align: left;
                width:70px !important;
                // line-height: 20px;
            }
            .el-form-item__content{
                margin-left:70px !important;
            }
            .input{
                .el-input__inner{
                    border:none;
                    padding:0;
                }
            }
            .input-sel{
                width:calc(100% - 40px);
            }
            .sel-txt,.resign-txt{
                color: $default-color;
                font-size: 12px;
                font-style: italic;
                display: inline-block;
                text-align: center;
            }
            .sign-btn{
                width:100%;
                color: #38c7c4;
                border-color: $default-color;
                background-color: #fff;
                .img{
                    display: inline-block;
                    width:16px;
                    height:16px;
                    background: url(/img/icon-sign.00caefc8.png) no-repeat center center;
                    background-size: 100% 100%;
                    vertical-align: middle;
                    margin-right: 5px;
                }
            }
            .el-radio-group{
                font-size: 0;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                height: 40px;
                line-height: 40px;
            }
            .el-radio{
                display:flex;
                flex-direction:row;
                align-items:center;
                justify-content:flex-start;
            }
        }
        .submit-btn{
            position: absolute;
            bottom: 0;
            width: 100%;
            margin-bottom: 0;
            padding: 10px 0;
            text-align: center;
            border-top:1px solid $border-color;
            font-size:18px;
            background:#fff;
            .el-form-item__content{
                margin-left:0 !important;
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                align-items: center;
            }
            .el-button--primary {
                color: #FFF;
                background-color: $default-color;
                border-color: $default-color;
                width:150px;
                height:44px;
                background:$default-color;
                border-radius:5px;
                font-size: 18px;
            }
            .btn-cancel{
                background-color:#fff;
                color:$default-color;
            }
        }
        .el-radio__original,.el-radio__input,.el-radio__inner{
            width: 23px;
            height: 23px;
        }
        .el-radio__input.is-checked .el-radio__inner{
            border-color: $default-color;
            background: $default-color;
            width: 23px;
            height: 23px;
        }
        .el-radio__inner::after{
            display: inline-block;
            width:14px;
            height:14px;
            background: url("../../assets/images/sel-checked.png") no-repeat center center;
            background-size: 100% 100%;
            vertical-align: middle;
            margin-right: 5px;
        }
        .el-radio__input.is-checked+.el-radio__label{
            color:$default-color;
        }
        .el-textarea__inner:focus{
            border-color:$default-color;
        }
    }
</style>